import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import {classesDaCategoria, useEstilosAcompanhamento} from './estilosAcompanhamento.js';

/* Painel auxiliar em lista (padrão de dashboard): ícone e valor na cor da categoria, sem navegação. */
export default function PainelLista({itens}) {
    const classes = useEstilosAcompanhamento();

    return (
        <List dense disablePadding>
            {itens.map(({chave, rotulo, valor, secundario, categoria, Icon}, indice) => {
                const {valueClass} = classesDaCategoria(classes, categoria);
                return (
                    <ListItem key={chave} disableGutters divider={indice < itens.length - 1}>
                        <ListItemIcon>
                            <Icon className={valueClass}/>
                        </ListItemIcon>
                        <ListItemText primary={rotulo} secondary={secundario}/>
                        <Typography variant='h6' component='span' className={clsx(classes.listaValor, valueClass)}>
                            {valor}
                        </Typography>
                    </ListItem>
                );
            })}
        </List>
    );
}

PainelLista.propTypes = {
    itens: PropTypes.arrayOf(PropTypes.shape({
        chave: PropTypes.string.isRequired,
        rotulo: PropTypes.string.isRequired,
        valor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        secundario: PropTypes.string,
        categoria: PropTypes.string.isRequired,
        Icon: PropTypes.elementType.isRequired
    })).isRequired
};
